import React, { useState, useMemo } from "react";
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
} from "react-google-maps";
import InfoWindow from "react-google-maps/lib/components/InfoWindow";

const parseCoordenada = (coordenadaGps) => {
  if (!coordenadaGps || typeof coordenadaGps !== "string") return null;
  const parts = coordenadaGps.split(",").map((p) => parseFloat(p.trim()));
  if (parts.length < 2 || isNaN(parts[0]) || isNaN(parts[1])) return null;
  return { lat: parts[0], lng: parts[1] };
};

const DEFAULT_CENTER = { lat: -34.64068679190589, lng: -58.5683013767203 };

const MapRadiologia = ({ centros = [] }) => {
  const [activeMarker, setActiveMarker] = useState(null);

  const markers = useMemo(() => {
    return (Array.isArray(centros) ? centros : [])
      .map((item, index) => {
        const position = parseCoordenada(item.coordenadaGps);
        if (!position) return null;
        return {
          id: index,
          name: (
            <p>
              <b>{item.centro}</b>
              <br />
              {item.ubicacion}
            </p>
          ),
          position,
        };
      })
      .filter(Boolean);
  }, [centros]);

  const center = useMemo(() => {
    if (markers.length > 0) return markers[0].position;
    return DEFAULT_CENTER;
  }, [markers]);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) return;
    setActiveMarker(marker);
  };

  return (
    <>
      <GoogleMap zoom={12} center={center}>
        {markers.map(({ id, name, position }) => (
          <Marker
            key={id}
            position={position}
            onClick={() => handleActiveMarker(id)}
          >
            {activeMarker === id ? (
              <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                <div>{name}</div>
              </InfoWindow>
            ) : null}
          </Marker>
        ))}
      </GoogleMap>
    </>
  );
};

export default withScriptjs(withGoogleMap(MapRadiologia));
